import { IconNameType } from '../Icon'

export enum ModalityCodesEnum {
  PR = 'PR', // Presencial
  SP = 'SP', // Semi-presencial
  OL = 'OL', // Online
  DI = 'DI', // Distancia
  DU = 'DU' // Dual
}

/**
 * Mapea códigos de modalidad a sus respectivos iconos
 */
export const modalityIconMap: Record<ModalityCodesEnum, IconNameType> = {
  [ModalityCodesEnum.PR]: 'class_onsite',
  [ModalityCodesEnum.SP]: 'class_hybrid',
  [ModalityCodesEnum.OL]: 'class_online',
  [ModalityCodesEnum.DI]: 'class_distance',
  [ModalityCodesEnum.DU]: 'class_dual'
}

/**
 * Mapea códigos de modalidad a sus respectivos textos descriptivos
 */
export const modalityLabelMap: Record<ModalityCodesEnum, string> = {
  [ModalityCodesEnum.PR]: 'Presencial',
  [ModalityCodesEnum.SP]: 'Semi-presencial',
  [ModalityCodesEnum.OL]: 'Online',
  [ModalityCodesEnum.DI]: 'Distancia',
  [ModalityCodesEnum.DU]: 'Dual'
}

/**
 * Obtiene el icono correspondiente a una modalidad
 * @param modality - Código de modalidad
 * @returns Nombre del icono a utilizar
 */
export const getModalityIcon = (
  modality: ModalityCodesEnum
): IconNameType | undefined => {
  return modalityIconMap[modality]
}

/**
 * Obtiene el label correspondiente a una modalidad
 * @param modality - Código de modalidad
 * @returns Texto descriptivo de la modalidad
 */
export const getModalityLabel = (modality: ModalityCodesEnum): string => {
  return modalityLabelMap[modality]
}
